/************
 * Model Class
 * File Name ...: case-member.components.ts
 * Generated By : ianday on 3/8/24
 * Date ........: 3/8/24
 /************/
import {ValidationResult} from './validation-result';

export interface CaseMember {
    id: number;
    caseId: number;
    memberId: number;
    primaryApplicantFlag: number;
    relationship: string;
}

export class CaseMember {
    constructor() {
        this.id = 0;
        this.caseId = 0;
        this.memberId = 0;
        this.primaryApplicantFlag = 0;
        this.relationship = '';
    }

}
